import "./sidecolumn.scss";
import { close } from "../../helpers/constant/imageUrl";
import { useDispatch } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { hide, setActiveIndex } from "../../redux/SideBarSlice";
import { setNav_Item } from "../../redux/NavBarSlice";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useEffect, useRef } from "react";
import useActiveNavItem from "../../customhooks/UseActiveNavItem";

const MainSideColumn = ({ products, activeIndex, suppressHighlight = false, onProductClick, title }) => {
  const dispatch = useDispatch();
  const sidebarRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const normalize = (path) => path?.replace(/\/+$/, "");

  const isItemActive = (item) => {
    const current = normalize(location.pathname);

    // parent match
    if (item.path) {
      const target = normalize(item.path);
      if (current === target || current.startsWith(target + "/")) {
        return true;
      }
    }

    // child match
    if (item.segments?.length) {
      return item.segments.some((seg) => {
        const segPath = normalize(seg.path);
        return current === segPath || current.startsWith(segPath + "/");
      });
    }

    return false;
  };

  useActiveNavItem();

  function handleClose() {
    dispatch(hide());
    dispatch(setActiveIndex(null));
  }

  useEffect(() => {
    if (!products || !products.length) return;

    const indexFromRoute = products.findIndex(
      (item) => isItemActive(item) && item.segments && item.segments.length > 0
    );

    if (indexFromRoute !== -1 && indexFromRoute !== activeIndex) {
      onProductClick(indexFromRoute);
    }
  }, [location.pathname, products]);

  return (
    <div className="product-list" ref={sidebarRef}>
      {/* Close Button */}
      <div className="close" onClick={handleClose}>
        <CloseRoundedIcon style={{ fontSize: "28px", color: "white" }} />
      </div>

      <h1>{title}</h1>

      <div className="list">
        {/* {products.map((item, index) => {
          const activeByRoute = isItemActive(item);
          const isActive = activeIndex === index || activeByRoute;
          return;
          <div
            className={`product-card ${activeIndex === index ? "active" : ""}`}
            key={index}
            onClick={() => onProductClick(index)}
          >
             <img  loading="lazy"
              src={item.img}
              alt={item.text}
              className="product-image"
               
            />

            {!item.segments || item.segments.length === 0 ? (
              <p className="product-text">
                <NavLink to={item.path}>{item.text}</NavLink>
              </p>
            ) : (
              <p
                className={`product-text ${
                  activeIndex === index ? "active" : ""
                }`}
              >
                {item.text}
              </p>
            )}
          </div>;
        })} */}
        {products.map((item, index) => {
          const isActive = !suppressHighlight && activeIndex !== null && activeIndex === index;

          return (
            <div
              key={index}
              className={`product-card ${isActive ? "active" : ""}`}
              onClick={() => {
                // only open child column if children exist
                if (item.segments && item.segments.length > 0) {
                  onProductClick(index);
                } else if (item.path) {
                  // leaf node → navigate & close sidebar
                  navigate(item.path);
                  dispatch(hide());
                  dispatch(setActiveIndex(null));
                }
              }}
            >
              
               <img  loading="lazy" src={item.img} alt={item.text} />

              <p className={`product-text ${isActive ? "active" : ""}`}>
                {item.path ? (
                  <NavLink to={item.path}>{item.text}</NavLink>
                ) : (
                  item.text
                )}
              </p>
            </div>
          );
        })}
      </div>
    
       
    </div>
  );
};

export default MainSideColumn;
